import classNames from 'classnames';
import React from 'react';

import styles from './button-link.scss';

interface ButtonLinkProps {
  children: React.ReactNode;
  className?: string;
  dataHook?: string;
  onClick(): any;
  onMouseLeave?(): any;
  disabled?: boolean;
}

export const ButtonLink = ({
  children,
  className,
  dataHook,
  onClick,
  ...props
}: ButtonLinkProps) => (
  <button
    className={classNames(styles.buttonLink, className)}
    data-hook={dataHook}
    onClick={onClick}
    {...props}
  >
    {children}
  </button>
);
